import { render, staticRenderFns } from "./StudyInstituteCreateDialog.vue?vue&type=template&id=4b965dc6"
import script from "./StudyInstituteCreateDialog.vue?vue&type=script&lang=ts"
export * from "./StudyInstituteCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports